var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chat-csat-popup',{attrs:{"visible":_vm.visible,"loading":_vm.loading,"error":_vm.failed},on:{"submit":_vm.onSubmit,"close":_vm.onDismiss}})
}
var staticRenderFns = []

export { render, staticRenderFns }